import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp, Sizes } from '@lean-body/components/styles';
import { drawerWidth } from '@lean-body/components/styles/utils';
import { FIXED_FOOTER_HEIGHT } from './fixed_footer';
export const HomeContentBackground = ({ children, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.fixedBackdrop), "aria-hidden": true },
            React.createElement("img", { className: css(styles.backgroundImage), src: "/assets/images/home_daily_lesson_map_background.svg", alt: "" })),
        React.createElement("div", { className: css(styles.content) }, children)));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
    },
    fixedBackdrop: {
        position: 'fixed',
        top: Sizes.MobileHeaderHeight,
        left: 0,
        right: 0,
        bottom: FIXED_FOOTER_HEIGHT,
        overflow: 'hidden',
        pointerEvents: 'none',
        backgroundImage: Colors.BackgroundHomeMap,
        [MediaBreakPointUp.MD]: {
            left: drawerWidth.md,
            bottom: 0,
        },
        [MediaBreakPointUp.XL]: {
            left: drawerWidth.xl,
            top: 60,
        },
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center center',
        userSelect: 'none',
    },
    content: {
        position: 'relative',
        flex: 1,
        minHeight: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
});
